import { Model } from '@vuex-orm/core'

export default class Client extends Model {
    static entity = "client"
    static fields () {
        return {
            id: this.attr(null),
            project: this.attr(null),
            client: this.attr(null)
        }
    }

}